import React from "react"
import { StposYaml } from "../../types/graphql-types"

export const categories: String[] = ["Fachdidaktik", "Schnittstellenmodul"]

export const containerHeadingOfCategory = (category: String): String => {
  switch (category) {
    case "Fachdidaktik":
      return "Fachdidaktische Lehrveranstaltungen"
    case "Schnittstellenmodul":
      return "Schnittstellenmodule"
  }
}

interface CategoryHeading {
  category: String
  activeStpo: StposYaml
}

export const CategoryHeading: React.FC<CategoryHeading> = ({
  category,
  activeStpo,
}) => (
  <div class="md:h-16 mb-4">
    <h3 class="text-xl lg:text-2xl inline-block">
      {containerHeadingOfCategory(category)}
    </h3>{" "}
    <div class="inline-block text-umr-grey-500">
      gemäß der {activeStpo?.title.short}
    </div>
  </div>
)
